import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications

import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { TimeframeSurcharge } from 'src/app/shared/models/timeframeSurcharges.model';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';
import { setCurrencyCode } from '@syncfusion/ej2-base';

setCurrencyCode('AUD');

@Component({
  selector: 'app-timeframe-surcharge-create',
  templateUrl: './timeframe-surcharge-create.component.html',
  styleUrls: ['./timeframe-surcharge-create.component.scss']
})
export class TimeframeSurchargeCreateComponent implements OnInit {

      @ViewChild('traceForm') traceForm: any;

    model: any;
    job_types: Object;
    job_type_locations: Object;
    count2: any;
    get_latest_court_id: Object;
    job_type_court: Object;
  
    @Input() intialCount = 221;
    @Input() count = this.intialCount;
    // sees if there is a change in myCount
  @Output()
  change: EventEmitter<number> = new EventEmitter<number>();
    job_type: Object;
    job_type_location: Object;
  
  
    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
    job_service_rules: any;
    subject_service_type: any;
  timeframe_surcharge: any;


  timeUnits: string[] = ['Hours', 'Days', 'Weeks'];
  selectedTimeUnit: string = 'Hours'; // default value
  
  public cValue: string = "#1de4d7";
  get_latest_timeframe_surcharge_id: Object;
  @Input('value')
  set value(value: any) {
      this.cValue = value;
  }
  search_model_duration_array: any[];
  duration_seconds: number;
duration_minutes: number;
duration_hours: number;





   // Text editor Settings
 public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo',
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
}; 



  constructor(
      private http: HttpClient,
  private _demoService: DemoService,
  private route: ActivatedRoute,
  private router: Router,
  public toastr: HotToastService,
  vcr: ViewContainerRef,
  private modalService: BsModalService, viewRef: ViewContainerRef,
  public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit(): void {
       this.model = new TimeframeSurcharge();
        // this.getJobServiceRules();
  }


  createTimeframeSurcharges(model) {
    // console.log(model);
        this._demoService.createTimeframeSurcharges(model).subscribe(
             data => {  this.get_latest_timeframe_surcharge_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Timeframe Surcharge :: Please try again!');
               console.log(error);
                              // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Timeframe Surcharge Added');
       };
 










    setColour(value2){
      console.log('SetColour: ' + value2)
      this.traceForm.colour.value = this.traceForm.colourpicker.value
    }
    


    getDurationFromMillisenconds(t) {
      let year,
          month,
          day,
          hour,
          minute,
          second;
    
      second = Math.floor(t / 1000);
      minute = Math.floor(second / 60);
      second = second % 60;
      hour = Math.floor(minute / 60);
      minute = minute % 60;
      day = Math.floor(hour / 24);
      hour = hour % 24;
      month = Math.floor(day / 30);
      day = day % 30;
      year = Math.floor(month / 12);
      month = month % 12;
    
      this.search_model_duration_array = []; // empty first
    
      this.search_model_duration_array.push({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        });
        this.search_model_duration_array = this.search_model_duration_array;
    
    
      // return { year, month, day, hour, minute, second };
      return year + 'yrs ' +  month + ' months ' + day + ' days ' + hour + ' hrs ' + minute + ' mins ' + second + ' sec ' ;
    
    
      // rewrite this scipt to return a model and oject so I can choose to dispaly or not and make a better UI system with the data
    
    
    
    }




    
    // Get Date Duration Between Two Dates
    getDateTimeDuration(a,b){
    // const firstDate: Date = new Date('2023-12-21');
    // // Current Date
    // const secondDate: Date = new Date();
    
    
    this.model.Duration = 0;// set to null
    
    
    const firstDate: Date = b;
    const secondDate: Date = a;
    
    
    // Time Difference in Milliseconds
    const milliDiff: number = firstDate.getTime()
        - secondDate.getTime();
    
    // Converting time into hh:mm:ss format
    
    // Total number of seconds in the difference
    const totalSeconds = Math.floor(milliDiff / 1000);
    
    // Total number of minutes in the difference
    const totalMinutes = Math.floor(totalSeconds / 60);
    
    // Total number of hours in the difference
    const totalHours = Math.floor(totalMinutes / 60);
    
    // Getting the number of seconds left in one minute
    const remSeconds = totalSeconds % 60;
    
    // Getting the number of minutes left in one hour
    const remMinutes = totalMinutes % 60;
    
    console.log(`${totalHours}:${remMinutes}:${remSeconds}`);
    
    this.duration_seconds = totalSeconds;
    this.duration_minutes = totalMinutes;
    this.duration_hours = totalHours;
    
    // now run the function to build the duration model
    this.toastr.info('Re calculating Item Duration')
    
    // set back the main variables
    // this.model.Duration = milliDiff;
    // this.model.StartTime = a;
    // this.model.EndTime = b;
    
    this.model.Duration = milliDiff;
    this.model.when_from = a
    this.model.when_to = b
    
    
    return milliDiff; // returns the difference in milliseconds.
    }
    
    
    getTimeFromNow(a, b){
    
    const firstDate: Date = b;
    const secondDate: Date = a;
    
    return moment(b, 'YYYYMMDD').fromNow()
    
    }



    onModelChange(model: any): void {
      if (!model.timeframe_from || !model.timeframe_to) {
        model.timeframe_duration_ms = 0;
        return;
      }
    
      const from = new Date(model.timeframe_from);
      const to = new Date(model.timeframe_to);
      const diffMs = Math.abs(to.getTime() - from.getTime());
    
      // Always store ms as base
      model.timeframe_duration_ms = diffMs;

      this.model.timeframe_duration_ms = diffMs;
    
      // Optional: convert to readable breakdown
      this.getDurationFromMillisenconds(diffMs);
    }











}
